import React, { useEffect, useState } from 'react'
import getEventServices from '../services/getEventServices';
import Header from './Header';
import './Events.css';
import { Modal, Button } from 'react-bootstrap';
import { DataViewRanking } from './Ranking'
import Swal from 'sweetalert2';
import rankingForEventServices from '../services/rankingForEventServices';

const Events = () => {
    const [dataEvents, setDataEvents] = useState([]);
    const [errors, setErrors] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedEventId, setSelectedEventId] = useState(null);
    const [eventName, setEventName] = useState(null);
    const token = localStorage.getItem('token');

    const consultEvents = async () => {
        try {
            const response = await getEventServices();
            setDataEvents(response);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        consultEvents();
    }, [])

    const handleShowModal = async (eventId) => {
        try {
            const existRanking = await rankingForEventServices(eventId);

            if (existRanking.length > 0) {
                setSelectedEventId(eventId);
                setShowModal(true);
            } else {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'no hay ranking disponible, a este evento',
                    customClass: {
                        title: "text-center"
                    },
                    showConfirmButton: false, // Mostrar el botón de confirmación
                    timer: 2500,
                    timerProgressBar: true,
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEventId(null);
    };

    return (
        <>
            <div className="events-container w-100">
                <Header />
                <div className="row external-bg-container-include d-flex justify-content-center align-items-start pt-5 vh-100 overflow-y-scroll">
                    <div className="container d-flex justify-content-center align-items-center flex-column mt-5">
                        <div className="col-12 m-0 p-0 mt-5">
                            <h1 className="text-center title-text-ranking text-white mt-5">Eventos</h1>
                            <div className="container-event">
                                <div className="container">
                                    <div className="row g-lg-4 g-2 justify-content-center">
                                        {dataEvents.map((event) => (
                                            <React.Fragment key={event.id}>
                                                <div className="col-xl-6 col-lg-6 col-md-4 col-sm-6 col-12">
                                                    <div id={`cardEvent-${event.id}`} className="event-card text">
                                                        {/* Badge con estado, nombre y fecha de creación */}
                                                        <div className="single-event text-center d-flex flex-column align-items-center justify-content-center">
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <div className="badge" style={{ backgroundColor: event.is_active ? 'green' : 'red' }}>
                                                                    {event.is_active ? 'Activo' : 'Inactivo'}
                                                                </div>
                                                            </div>
                                                            <div className="content-event-title text-dark">
                                                                {event.name}
                                                                {event.creationDate}
                                                                <button type="submit" className="form-container-button w-100 lowercase border border-dark" onClick={() => handleShowModal(event.id, event.name)}>Ver ranking</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* footer mobile */}
                    <footer className="d-block d-md-block d-lg-none d-xl-none col-12 mt-auto">
                        <div className="d-flex justify-content-between align-items-center text-white mb-2">
                            <div className='mx-4 mb-3'>
                                <img src="./Logo-Footer-1.png" style={{ width: '70%' }} alt="logo" />
                            </div>
                            <div className='text-end mx-4 mb-3'>
                                <img src="./Logo-Footer-2.png" style={{ width: '150%', marginLeft: '-85px' }} alt="logo" />
                            </div>
                        </div>
                    </footer>

                    <footer className="d-none d-md-none d-lg-block d-xl-block col-12 mt-auto bg-transparent">
                        <div className="d-flex justify-content-between align-items-center text-white mb-2">
                            <div className='mx-4 mb-3'>
                                <img src="./Logo-Footer-1.png" style={{ width: '15%' }} alt="logo" />
                            </div>
                            <div className='text-end mx-4 mb-3'>
                                <img src="./Logo-Footer-2.png" style={{ width: '35%' }} alt="logo" />
                            </div>
                        </div>
                    </footer>
                </div>
            </div>

            {/* Modal */}
            <Modal show={showModal} onHide={handleCloseModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Ranking del Evento</Modal.Title>
                </Modal.Header>
                {selectedEventId && <DataViewRanking eventId={selectedEventId} />}
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Events;